import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import axios from 'axios';
import connection from './connection';

export class QaqcAnalysisService {
    URL = connection.DEPLOY_URL + '/qaqc-analysis';

    async getWorkOrdersForQAQC(req?: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getWorkOrdersForQAQC', req)
            .then(res => {
                return res.data
            })
    }

    async getWorkOrdersDropdownForQAQC(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getWorkOrdersDropdownForQAQC')
            .then(res => {
                return res.data
            })
    }

    async getLotsDropdownForQAQC(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getLotsDropdownForQAQC')
            .then(res => {
                return res.data
            })
    }

    async getLotsForQAQC(req?: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getLotsForQAQC', req)
            .then(res => {
                return res.data
            })
    }

    async getLotsForProductCountsQAQC(req?: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getLotsForProductCountsQAQC', req)
            .then(res => {
                return res.data
            })
    }

    async createFibreAnalysis(createDto: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createFibreAnalysis', createDto)
            .then(res => {
                return res.data
            })
    }

    async createFibreLabAnalysis(createDto: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createFibreLabAnalysis', createDto)
            .then(res => {
                return res.data
            })
    }

    async getAllFibreAnalysis(req?: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllFibreAnalysis', req)
            .then(res => {
                return res.data
            })
    }

    async getAllFibreLabAnalysis(req?: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllFibreLabAnalysis', req)
            .then(res => {
                return res.data
            })
    }

    async getFibreAnalysisByWorkOrder(workOrderNo: string): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getFibreAnalysisByWorkOrder', { workOrderNo })
            .then(res => {
                return res.data
            })
    }

    async getFibreAnalysisByLot(lotNumber: string): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getFibreAnalysisByLot', { lotNumber })
            .then(res => {
                return res.data
            })
    }

    async getFibreLabAnalysisByWorkOrder(workOrderNo: string): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getFibreLabAnalysisByWorkOrder', { workOrderNo })
            .then(res => {
                return res.data
            })
    }

    async getFibreLabAnalysisByLot(lotNumber: string): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getFibreLabAnalysisByLot', { lotNumber })
            .then(res => {
                return res.data
            })
    }

    async updateFibreAnalysis(updateDto: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateFibreAnalysis', updateDto)
            .then(res => {
                return res.data
            })
    }

    async updateFibreLabAnalysis(updateDto: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateFibreLabAnalysis', updateDto)
            .then(res => {
                return res.data
            })
    }

    async approveQaqcTest(approvalDto: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/approveQaqcTest', approvalDto)
            .then(res => {
                return res.data
            })
    }

    async createProductCounts(createDto: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createProductCounts', createDto)
            .then(res => {
                return res.data
            })
    }

    async getProductCounts(req?: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getProductCounts', req)
            .then(res => {
                return res.data
            })
    }

    async updateProductCounts(updateDto: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateProductCounts', updateDto)
            .then(res => {
                return res.data
            })
    }

    async approveProductCounts(approvalDto: any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/approveProductCounts', approvalDto)
            .then(res => {
                return res.data
            })
    }
}
